import type { FC } from 'react';

import InputDateSimple from '../../../input_date_simple/input_date_simple';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'dateFormat',
  'outputFormat',
  'isRangeMode',
  'initialMonth',
  'matchSelectValue',
  'formatSelectValue',
  'onValueChange',
  // validations prop used to disable unavailable dates in calendar
  // according to minDate and maxDate
  'validations',
  'relativeToDate',
  'isDynamicWidth',
] as const;

const Field = formField(InputDateSimple, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type DateSimpleFieldWrapperProps = FieldWrapperProps<typeof Field>;

const SimpleDateFieldWrapper: FC<DateSimpleFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default SimpleDateFieldWrapper;
